import ViewBase from "../../../../view-base.view";

export default function Step3() {
  ViewBase.call(this);
  let onGoBack = () => { };
  let onGoBackList = () => { };
  let viewCampaign = () => {};
  let _campaignId;
  let _campaignName
  return {
    oninit: ({ attrs: { onBack, goBackList, onViewCampaign, campaignId, campaignName } }) => {
      if (onBack) {
        onGoBack = onBack;
      }

      if (goBackList) {
        onGoBackList = goBackList;
      }

      if(onViewCampaign) {
        viewCampaign = onViewCampaign
      }

      if (campaignId) {
        _campaignId = campaignId
      }

      if(campaignName) {
        _campaignName = campaignName
      }

    },
    view: (vnode) => {
      return [
        m('.row',
          m("p", { style: { "text-align": "center", "color": '#198754' } },
            m("p", { style: { 'font-size': '3rem' } }, m("i.bi.bi-emoji-smile")),
            m("h4", { style: { "color": '#198754' } }, 'Campaign registered successfully!')
          ),
          m('.row',
            m('.col-md-12.gap-2.mt-4.d-flex.justify-content-center',
              m(
                "button.btn.btn-white[type='button']", { onclick: onGoBack },
                this.getText("LT00001205", "Go Back")
              ),
              m('button.btn.btn-white[type="button"].px-4.gap-3', {onclick: onGoBackList}, this.getText('LT00001238', "Go Back to List")),
              m('button.btn.btn-primary[type="button"].px-4.gap-3', {onclick: () => viewCampaign(_campaignId, _campaignName)}, this.getText("LT00001312", "View Uploaded Images")),
            )
          )),
        this.getBaseViews()
      ]
    }
  }
}